import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { UserApi } from '../../api';
import { useCardTypes } from '../../hooks/useCardTypes';
import { CardTypeModal, CardTypeModalRef } from '../molecules/CardTypeModal';

export const GlobalCardTypeGate: React.FC = () => {
  const { data: user } = useQuery('user', UserApi.fetch);
  const { data: cardTypeOptions = [] } = useCardTypes();
  const modalRef = useRef<CardTypeModalRef>(null);

  const [forceAcceptedAfterAgreements, setForceAcceptedAfterAgreements] = useState(false);

  const requiredAcceptedFromUser = useMemo(() => {
    if (!user?.agreements) return false;
    const required = user.agreements.filter(a => Number(a.required) === 1);
    return required.length === 0 || required.every(a => Number(a.has_agree) === 1);
  }, [user?.agreements]);

  const requiredAccepted = requiredAcceptedFromUser || forceAcceptedAfterAgreements;

  const canAskForType = useMemo(() => {
    if (!user) return false;
    const ct = Number(user.card_type ?? 0);
    return requiredAccepted && (ct === 0 || Number.isNaN(ct));
  }, [user, requiredAccepted]);

  useEffect(() => {
    const handleOpen = () => {
      modalRef.current?.open();
    };

    window.addEventListener('open-card-type-modal', handleOpen);
    return () => window.removeEventListener('open-card-type-modal', handleOpen);
  }, []);

  useEffect(() => {
    const handler = () => {
      setForceAcceptedAfterAgreements(true);

      const ct = Number(user?.card_type ?? 0);
      if (ct === 0 || Number.isNaN(ct)) {
        modalRef.current?.open();
      }
    };

    window.addEventListener('agreements-saved', handler);
    return () => window.removeEventListener('agreements-saved', handler);
  }, [user?.card_type]);

  useEffect(() => {
    if (!canAskForType) return;
    const id = setTimeout(() => {
      modalRef.current?.open();
    }, 50);
    return () => clearTimeout(id);
  }, [canAskForType]);

  if (!user) return null;

  return (
    <CardTypeModal
      ref={modalRef}
      options={cardTypeOptions}
      current={user.card_type}
      requiredAgreementsAccepted={requiredAccepted}
    />
  );
};